import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";

const cols = [
  {
    title: "Products",
    links: [
      { label: "MFInsure® Core", to: "/products/core" },
      { label: "MFInsure® GRIP", to: "/products/grip" },
      { label: "Gradatim Intelligence®", to: "/products/intelligence" },
    ],
  },
  {
    title: "Company",
    links: [
      { label: "Platform", to: "/platform" },
      { label: "Insights", to: "/insights/case-study" },
      { label: "Contact", to: "/#contact" },
    ],
  },
  {
    title: "Locations",
    links: [
      { label: "India", to: "/#contact" },
      { label: "Singapore", to: "/#contact" },
    ],
  },
];

export const Footer = () => {
  return (
    <footer data-testid="footer" className="bg-ink text-white border-t border-white/10">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-16">
          <div className="lg:col-span-5">
            <Link to="/" className="flex items-center gap-2">
              <span className="h-2.5 w-2.5 bg-copper inline-block" />
              <span className="font-display text-2xl">Gradatim</span>
            </Link>
            <p className="mt-6 text-slate-400 max-w-sm leading-relaxed text-sm">
              Flexible core policy administration platform — configurable,
              extensible, scalable and smart. Engineered for incumbents
              reimagining insurance software.
            </p>
            <Link
              to="/#contact"
              data-testid="footer-cta"
              className="group inline-flex items-center gap-2 mt-8 text-copper hover:text-white transition-colors link-underline"
            >
              Connect with us
              <ArrowUpRight className="h-4 w-4 transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
            </Link>
          </div>

          <div className="lg:col-span-7 grid grid-cols-2 md:grid-cols-3 gap-8">
            {cols.map((col) => (
              <div key={col.title}>
                <div className="overline text-copper mb-5">{col.title}</div>
                <ul className="space-y-3">
                  {col.links.map((l) => (
                    <li key={l.label}>
                      <Link
                        to={l.to}
                        className="text-sm text-slate-300 hover:text-white link-underline"
                        data-testid={`footer-link-${l.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                      >
                        {l.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-xs text-slate-500">
          <p>© {new Date().getFullYear()} Gradatim IT Ventures India Private Limited. All rights reserved. MFInsure® is a registered trademark.</p>
          <div className="flex items-center gap-5">
            <Link
              to="/privacy"
              data-testid="footer-link-privacy"
              className="text-slate-400 hover:text-white transition-colors"
            >
              Privacy
            </Link>
            <Link
              to="/terms"
              data-testid="footer-link-terms"
              className="text-slate-400 hover:text-white transition-colors"
            >
              Terms
            </Link>
            <span className="font-mono">Step-by-Step in Degrees</span>
          </div>
        </div>
      </div>
    </footer>
  );
};
